var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40002071_83585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 6.22933C1.4375 3.31832 3.79733 0.958496 6.70833 0.958496C9.61937 0.958496 11.9792 3.31832 11.9792 6.22933C11.9792 9.14033 9.61937 11.5002 6.70833 11.5002C3.79733 11.5002 1.4375 9.14033 1.4375 6.22933Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8957 6.22933C13.8957 7.66715 13.4735 9.00638 12.7463 10.1297C13.6825 10.9812 14.9264 11.5002 16.2916 11.5002C19.2026 11.5002 21.5624 9.14033 21.5624 6.22933C21.5624 3.31832 19.2026 0.958496 16.2916 0.958496C14.9264 0.958496 13.6825 1.47746 12.7463 2.32887C13.4735 3.45228 13.8957 4.7915 13.8957 6.22933Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2498C0 15.1328 1.71624 13.4165 3.83333 13.4165H9.58333C11.7004 13.4165 13.4167 15.1328 13.4167 17.2498V21.0832C13.4167 21.6125 12.9876 22.0415 12.4583 22.0415H0.958333C0.429061 22.0415 0 21.6125 0 21.0832V17.2498Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 17.2498V22.0415H22.0417C22.5709 22.0415 23 21.6125 23 21.0832V17.2498C23 15.1328 21.2837 13.4165 19.1667 13.4165H13.8692C14.7796 14.4338 15.3333 15.7772 15.3333 17.2498Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40002071_83585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/ManageUsers.677b9e6c74ae3112a26efa0780af5a5d.svg";
export { ForwardRef as ReactComponent };